module.exports = __webpack_public_path__ + "static/media/waardenkaart-zorg.93dd0e75.png";